// MANDASA JS START

(function () {
  
  if (window.innerWidth > 500) return;

  function loadjQuery(callback) {
    if (window.jQuery) return callback();
    const script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    script.onload = callback;
    script.onerror = () => console.error('Failed to load jQuery.');
    document.head.appendChild(script);
  }


  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const shadowRoot = originalAttachShadow.call(this, init);
    this._shadowRoot = shadowRoot;
    return shadowRoot;
  };

  function applyMobileStyles() {
    const host = document.querySelector('.sel-embedded.sel-footer-left');
    if (!host || !host._shadowRoot) {
      return setTimeout(applyMobileStyles, 300);
    }

    const $target = $(host._shadowRoot).find('.sc-hvigdm.fOjyrj.sel-bothContainer');
    if ($target.length) {
      $target.css({
        'flex-wrap': 'wrap',
        'justify-content': 'center'
      });
    
      return true;
    } else {
      
      setTimeout(applyMobileStyles, 300);
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    loadjQuery(() => applyMobileStyles());
  });
})();


// MANDASA JS END


// LENOITES: visa nyansnamn ovanfor fargpluppar i produktkort (som Victoria Beckham)
(function () {
  var LABEL_CLASS = 'lenoites-shade-label';

  function labelFor(container) {
    var existing = container.previousElementSibling;
    if (existing && existing.classList && existing.classList.contains(LABEL_CLASS)) {
      return existing;
    }
    var el = document.createElement('div');
    el.className = LABEL_CLASS;
    container.parentNode.insertBefore(el, container);
    return el;
  }

  function nameOf(wrapper) {
    var tip = wrapper.querySelector('.color-swatcher--tooltip');
    if (tip && tip.textContent.trim()) return tip.textContent.trim();
    var sw = wrapper.querySelector('.color-swatcher');
    return sw ? (sw.getAttribute('data-color') || '') : '';
  }

  function activeName(container) {
    var active = container.querySelector('.color-swatcher--wrapper.active');
    if (!active) active = container.querySelector('.color-swatcher--wrapper');
    return active ? nameOf(active) : '';
  }

  function wire(container) {
    if (container.dataset.lenoitesShadeLabel === '1') return;
    var wrappers = container.querySelectorAll('.color-swatcher--wrapper');
    if (!wrappers.length) return;
    container.dataset.lenoitesShadeLabel = '1';

    var label = labelFor(container);
    label.textContent = activeName(container);

    wrappers.forEach(function (wrapper) {
      wrapper.addEventListener('mouseover', function () {
        label.textContent = nameOf(wrapper);
      });
      wrapper.addEventListener('focus', function () {
        label.textContent = nameOf(wrapper);
      }, true);
      wrapper.addEventListener('click', function () {
        setTimeout(function () { label.textContent = activeName(container); }, 0);
      });
    });

    container.addEventListener('mouseleave', function () {
      label.textContent = activeName(container);
    });
  }

  function scan() {
    document
      .querySelectorAll('.card__color-swatcher--container')
      .forEach(wire);
  }

  function start() {
    scan();
    // korten sorteras om av color-swatch.js efter render, och fler kort
    // laddas in vid filtrering/paginering - kor darfor om vid DOM-andringar
    var pending = null;
    var mo = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(scan, 120);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
